








import videojs from "video.js";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "VideoPlayerComponent",
  components: {},
})
export default class VideoPlayerComponent extends Vue {
  public title = "会員の新規作成";
  public player = null;

  public url: string = null;

  // async mounted() {}

  public load(url: string) {
    console.log("load.", url);
    this.player = videojs(this.$refs.videoPlayer as HTMLElement, {
      autoplay: true,
      controls: true,
      sources: [
        {
          src: url,
          type: "application/x-mpegURL",
        },
      ],
    });
    this.url = url;
  }

  public stop() {
    if (this.player) {
      this.player.pause();
      this.player.src({});
      this.player.load();
      // this.player.dispose();
      // this.player = null;
    }
    this.url = null;
  }
}
